import { useContext } from 'react';
import AuthContext from '../Context/authProvider';

const useAuth = () => useContext(AuthContext);

export default useAuth;
